import PointerEvents from '../../../../vendor_core/core/src/const/PointerEvents';
import MessagePopup from '../../../../vendor_core/core/src/ui/popups/MessagePopup';
import ViewManager from '../../../../vendor_core/core/src/utils/ViewManager';
import TextField from '../../../../vendor_core/core/src/views/components/TextField';

export default class BBMessagePopup extends MessagePopup {
    public show(callback?: Function) {
        super.show(callback);
        // show popup background
        ViewManager.getLayer("PopupsBackground").setScene("open");
    }

    public hide = () => {
        super.hide();
        // clear popup background
        ViewManager.getLayer("PopupsBackground").clear();
    }
}
